<template>
    <div class="partner" v-loading="showLoading">
        <el-form ref="ruleFormRef" style="max-width: 600px" :model="ruleForm" :rules="rules" label-width="auto">
            <el-form-item label="合作方名称" prop="partnerName">
                <el-input v-model="ruleForm.partnerName" placeholder="请填写合作方名称" />
            </el-form-item>
            <el-form-item label="合作方简称" prop="abbreviation">
                <el-input v-model="ruleForm.abbreviation" placeholder="请填写合作方简称" />
            </el-form-item>
            <el-form-item label="合作方类型" prop="type">
                <el-select v-model="ruleForm.type" placeholder="请选择合作方类型" disabled>
                    <el-option v-for="item in partnerTypeOptions" :key="item.value" :label="item.label"
                        :value="item.value" />
                </el-select>
            </el-form-item>
            <!-- 标题图片 -->
            <el-form-item label="品牌图标" prop="brandImage">
                <div class="upload-wrapper">
                    <el-upload class="avatar-uploader" action="/shop/api/v1/merchant/savePartnerImage" :headers="header"
                        name="imageFile" :show-file-list="false" :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <template #default>
                            <div v-if="imageUrl" class="el-upload-list__item is-ready image-container">
                                <img :src="imageUrl" fit="cover" class="el-upload-list__item-thumbnail" />
                                <div class="image-actions">
                                    <el-icon class="action-icon" @click.stop="viewImage">
                                        <ZoomIn />
                                    </el-icon>
                                    <el-icon class="action-icon" @click.stop="removeImage">
                                        <Delete />
                                    </el-icon>
                                </div>
                            </div>
                            <el-icon v-else class="avatar-uploader-icon">
                                <Plus />
                            </el-icon>
                        </template>
                    </el-upload>
                    <div class="recommend-tip">推荐：图片尺寸 宽300px、高300px</div>
                </div>
            </el-form-item>
            <el-form-item label="前端展示" prop="shopState">
                <el-select v-model="ruleForm.shopState" placeholder="请选择前端展示方式">
                    <el-option v-for="item in shopStateOptions" :key="item.value" :label="item.label"
                        :value="item.value" />
                </el-select>
            </el-form-item>
            <el-form-item label="分类类型" prop="classificationType">
                <el-select v-model="ruleForm.classificationType" placeholder="请选择分类类型">
                    <el-option v-for="item in classificationOptions" :key="item.value" :label="item.label"
                        :value="item.value" />
                </el-select>
            </el-form-item>
            <el-form-item label="联系人姓名" prop="contacts">
                <el-input v-model="ruleForm.contacts" placeholder="请填写联系人姓名" />
            </el-form-item>
            <el-form-item label="账号" prop="accountNumber">
                <el-input v-model="ruleForm.accountNumber" disabled placeholder="请填写账号" />
            </el-form-item>
            <el-form-item label="密码">
                <el-input v-model="ruleForm.password" type="password" placeholder="请输入密码（留空默认不更改）" show-password />
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
                <el-input v-model="ruleForm.mobile" placeholder="请填写手机号" />
                <div style="color:#909399;">提示：多个手机号用英文逗号隔开</div>
            </el-form-item>
            <el-form-item label="登录权限" prop="state">
                <el-select v-model="ruleForm.state" placeholder="请选择登录权限">
                    <el-option v-for="item in loginStateOptions" :key="item.value" :label="item.label"
                        :value="item.value" />
                </el-select>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input v-model="ruleForm.sort" placeholder="请填写排序" />
                <div style="color:#909399;">提示：大到小排序 默认1000</div>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-model="ruleForm.remarks" type="textarea" />
            </el-form-item>
            <div class="hint_box">
                <div class="hint_title">提示：</div>
                <div class="hint_text">
                    1. 前端展示指的是前端店铺入口，特定活动合作方不能设置为前端展示。<br />
                    2. 手机号列表最多可以填写5个，用英文逗号分隔，当产生订单时会推送订单信息。<br />
                    3. 特定活动合作方指的是工会指定的活动承办方，产品在前端不允许搜索。<br />
                </div>
            </div>
            <el-form-item>
                <el-button type="primary" @click="submitForm(ruleFormRef)" :loading="submitLoading"
                    :disabled="submitLoading">
                    提交
                </el-button>
            </el-form-item>
        </el-form>
        <el-dialog v-model="dialogVisible" title="查看大图">
            <img :src="imageUrl" style="width: 100%">
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { Plus, ZoomIn, Delete } from '@element-plus/icons-vue';
import { useRouter, useRoute } from 'vue-router'; // 引入 useRoute
import {
    editPartnerData,
    // 假设存在获取合作方详情的接口
    getPartnerDetail
} from "../../../request/api";
import qs from 'qs';
const router = useRouter();
const route = useRoute(); // 获取当前路由信息
const header = ref({
    timeout: 10000,
    'accessToken': sessionStorage.getItem('token')
});
const ruleFormRef = ref();
const submitLoading = ref(false);
const showLoading = ref(true); //加载loading
const ruleForm = reactive({
    partnerName: '',
    abbreviation: '',
    type: '',
    shopState: '',
    remarks: '',
    classificationType: '',
    contacts: '',
    accountNumber: '',
    password: '',
    mobile: '',
    state: '',
    sort: '',
    brandImage: '',
});

const rules = {
    partnerName: [
        { required: true, message: '请填写合作方名称', trigger: 'blur' },
    ],
    abbreviation: [
        { required: true, message: '请填写合作方简称', trigger: 'blur' },
    ],
    type: [
        {
            required: true,
            message: '请选择合作方类型',
            trigger: 'change',
        },
    ],
    brandImage: [
        { required: true, message: "请上传品牌图标", trigger: "change" },
    ],
    shopState: [
        {
            required: true,
            message: '请选择前段展示方式',
            trigger: 'change',
        },
    ],
    classificationType: [
        {
            required: true,
            message: '请选择分类类型',
            trigger: 'change',
        },
    ],
    contacts: [
        { required: true, message: '请填写联系人姓名', trigger: 'blur' },
    ],
    accountNumber: [
        { required: true, message: '请填写账号', trigger: 'blur' },
    ],
    mobile: [
        { required: true, message: '请填写手机号', trigger: 'blur' },
    ],
    state: [
        {
            required: true,
            message: '请选择登录权限',
            trigger: 'change',
        },
    ],
}
const imageUrl = ref('');
const dialogVisible = ref(false);
// 定义分类选项（全局常量，避免重复定义）
const classificationOptions = [
    { label: '平台分类', value: '1' },
    { label: '自有分类', value: '2' }
];

// 合作方类型选项
const partnerTypeOptions = [
    { label: 'API对接', value: '1' },
    { label: '店铺合作方', value: '2' },
    { label: '特定活动合作方', value: '3' }
];
const shopStateOptions = [
    { label: '展示', value: '1' },
    { label: '不展示', value: '2' }
];
const loginStateOptions = [
    { label: '允许', value: '1' },
    { label: '不允许', value: '2' }
];
// 获取合作方详情
const fetchPartnerDetail = async () => {
    try {
        const params = {
            id: sessionStorage.getItem('partnerId'), // 替换为实际的合作方ID
        }
        getPartnerDetail(qs.stringify(params)).then((res) => {
            if (res.data.code === 0) {
                const data = res.data.data.partnerInfo;
                // 强制转为字符串，确保和选项value类型一致
                data.classificationType = String(data.classificationType);
                data.type = String(data.type);
                data.shopState = String(data.shopState);
                data.state = String(data.state);
                imageUrl.value = res.data.data.partnerInfo.brandImage;
                Object.assign(ruleForm, res.data.data.partnerInfo);
                showLoading.value = false;
            } else {
                ElMessage.error(res.data.msg || '获取合作方详情失败');
            }
        })
    } catch (error) {
        console.error('获取合作方详情出错:', error);
        ElMessage.error('获取合作方详情出错');
    }
};

onMounted(() => {
     fetchPartnerDetail();
});

// 提交表单
const submitForm = async (formEl) => {
    if (!formEl) return;

    // 如果正在提交中，直接返回
    if (submitLoading.value) return;

    try {
        submitLoading.value = true; // 开始加载

        // 先进行表单验证
        await formEl.validate();
        // 检查图片是否被重新上传
        if (!imageUrl.value || imageUrl.value === ruleForm.brandImage) {
            ruleForm.brandImage = ''; // 如果没有重新上传图片，则赋值为空
        }
        // 新增函数：将中文逗号（，）转为英文逗号（,）
        const convertCommas = (str) => {
            if (!str) return str;
            return str.replace(/，/g, ','); // 全局替换
        };

        // 准备请求参数
        const params = {
            id: sessionStorage.getItem('partnerId'), // ID
            partnerName: ruleForm.partnerName, //合作方名称
            abbreviation: ruleForm.abbreviation, //合作方简称
            type: ruleForm.type,  //合作方类型
            brandImage: ruleForm.brandImage,  //品牌图标
            shopState: ruleForm.shopState,  //展示方式
            classificationType: ruleForm.classificationType,  //分类类型
            contacts: ruleForm.contacts,  //联系人姓名
            password: ruleForm.password,  //密码
            mobile: convertCommas(ruleForm.mobile),  //手机号
            state: ruleForm.state,  //登录权限
            sort: ruleForm.sort,  //排序
            remarks: ruleForm.remarks,  //备注
        };
        // 调用API
        editPartnerData(params).then((res) => {
            if (res.data.code == 0) {
                ElMessage.success('编辑成功');
                submitLoading.value = false; // 结束加载
                setTimeout(() => {
                    router.push('/cooperativeManagement');
                }, 1000);
            } else {
                throw new Error(res.data.message || '提交失败');
            }
        })
    } catch (error) {
        console.error('提交出错:', error);
        // 如果是表单验证错误，Element会自动显示错误信息
        if (error.message !== '表单验证失败') {
            ElMessage.error(error.message || '提交失败');
        }
    }
};




const handleAvatarSuccess = (response, uploadFile) => {
    imageUrl.value = URL.createObjectURL(uploadFile.raw);
    ruleForm.brandImage = response.data.imagePath;
};

const beforeAvatarUpload = (rawFile) => {
    // 允许的图片格式
    const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp'];
    const isImage = ALLOWED_TYPES.includes(rawFile.type);
    const isLt1M = rawFile.size / 1024 / 1024 < 1;

    if (!isImage) {
        ElMessage.error('只能上传 JPG/PNG/GIF/WEBP/BMP 格式的图片!');
        return false;
    }
    if (!isLt1M) {
        ElMessage.error('上传图片大小不能超过 1MB!');
        return false;
    }
    return true;
};

const viewImage = () => {
    dialogVisible.value = true;
};

const removeImage = () => {
    imageUrl.value = '';
    ruleForm.brandImage = '';
};
</script>

<style lang="scss" scoped>
.partner {
    height: calc(100vh - 170px);
    background-color: #FFFFFF;
    width: 95%;
    padding: 20px;
    overflow: auto;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 5px;
    margin: 15px auto;
}

.avatar-uploader .avatar {
    width: 110px;
    height: 110px;
    display: block;
}

.upload-wrapper {
    display: flex;
    align-items: flex-end;
    /* 使子元素底部对齐 */
    gap: 10px;
    /* 设置元素之间的间距 */
}

.recommend-tip {
    color: #cccccc;
}

/* 新增的图片容器样式 */
.image-container {
    position: relative;

    &:hover .image-actions {
        opacity: 1;
    }
}

.image-actions {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    opacity: 0;
    transition: opacity 0.3s;
}

.action-icon {
    color: white;
    font-size: 24px;
    cursor: pointer;

    &:hover {
        color: var(--el-color-primary);
    }
}
</style>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 110px;
    height: 110px;
    text-align: center;
}

.avatar-uploader .el-upload-list__item {
    width: 110px;
    height: 110px;
}

.el-upload-list__item-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.el-form-item__label-wrap .el-form-item__label {
    font-weight: bold;
}

.el-upload-list__item {
    margin-bottom: 0;
}

.hint_box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .hint_title {
        width: 120px;
        text-align: right;
        color: #909399;
        font-weight: bold;
    }

    .hint_text {
        color: #909399;
        font-size: 14px;
    }
}
.el-input__inner{
    height: 38px !important;
    line-height: 38px!important;
}
</style>